import { render, staticRenderFns } from "./TerminalOrder.vue?vue&type=template&id=6e1dc5ce&scoped=true&"
import script from "./TerminalOrder.vue?vue&type=script&lang=js&"
export * from "./TerminalOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1dc5ce",
  null
  
)

export default component.exports